const Alert = ({ className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 12"
    fill="none"
    className={`${className}`}
  >
    <path
      d="M6 12C9.26214 12 12 9.27643 12 5.99418C12 2.71193 9.29709 0 6 0C2.71456 0 0 2.71193 0 5.99418C0 9.28807 2.71456 12 6 12ZM6 7.00679C5.53398 7.00679 5.20777 6.69253 5.19612 6.2386L5.09126 2.95635C5.07961 2.42095 5.45243 2.0485 6 2.0485C6.54757 2.0485 6.93204 2.42095 6.90874 2.95635L6.81553 6.2386C6.80388 6.69253 6.46602 7.00679 6 7.00679ZM6 9.91658C5.39417 9.91658 4.9165 9.45102 4.9165 8.84578C4.9165 8.26382 5.39417 7.79825 6 7.79825C6.60582 7.79825 7.08349 8.26382 7.08349 8.84578C7.08349 9.45102 6.60582 9.91658 6 9.91658Z"
      fill="#F64F4F"
    />
  </svg>
);

export default Alert;
